 // AOS
AOS.init({
once: true,
});

// JS
document.addEventListener('DOMContentLoaded', function () {
  // Mega Menu
  document.querySelectorAll('.mega-menu').forEach(function (megaMenu) {
    const menuMainView = megaMenu.querySelector('.menu_main_view');
    const menuCollectionsView = megaMenu.querySelector('.menu_collections_view');
    megaMenu.querySelectorAll('.collection_btn').forEach(function (item) {
      const handle = item.getAttribute('data-collection-handle');
      if (!handle) return;

      item.addEventListener('mousedown', function (e) {
        e.preventDefault();
        e.stopImmediatePropagation();

        megaMenu.open = true;

        menuMainView.style.display = 'none';

        megaMenu.querySelectorAll('.menu_collection').forEach(el => {
          el.classList.remove('is-active', 'is-visible');
        });

        menuCollectionsView.classList.add('is-collection-active');

        const targetCollection = megaMenu.querySelector(
          `.menu_collection[data-collection-handle="${handle}"]`
        );

        if (targetCollection) {
          targetCollection.classList.add('is-active');
          setTimeout(() => {
            targetCollection.classList.add('is-visible');
          }, 300);
        }
      });
    });

    // BACK LINK
    megaMenu.querySelectorAll('.menu_collection .back_link').forEach(function (backLink) {
      backLink.addEventListener('click', function (e) {
        e.preventDefault();
        e.stopImmediatePropagation();

        menuMainView.style.display = '';
        menuCollectionsView.classList.remove('is-collection-active');

        megaMenu.querySelectorAll('.menu_collection').forEach(el => {
          el.classList.remove('is-active', 'is-visible');
        });
      });
    });
  });
  // Drawer Menu
  document.querySelectorAll('.menu-drawer__navigation').forEach(function (drawer) {
    const mobmenuMainView = drawer.querySelector('.menu-drawer__menu');
    const menuMainBlock = drawer.querySelector('.mob_menu_block');
    const collectionsViews = drawer.querySelectorAll('.menu_collections_view');
    drawer.querySelectorAll('.collection_btn').forEach(function (item) {
      const handle = item.getAttribute('data-collection-handle');
      if (!handle) return;
      item.addEventListener('click', function (e) {
        e.preventDefault();
        e.stopPropagation();

        mobmenuMainView.style.display = 'none';
        menuMainBlock.style.display = 'none';

        collectionsViews.forEach(view => {
          view.classList.remove('is-collection-active');
          view.querySelectorAll('.menu_collection').forEach(col => {
            col.classList.remove('is-active', 'is-visible');
          });
        });
        const targetCollection = drawer.querySelector(
          `.menu_collection[data-collection-handle="${handle}"]`
        );
        if (!targetCollection) return;
        const wrapper = targetCollection.closest('.menu_collections_view');
        wrapper.classList.add('is-collection-active');
        targetCollection.classList.add('is-active');
        setTimeout(() => {
          targetCollection.classList.add('is-visible');
        }, 300);
      });
    });
    drawer.querySelectorAll('.menu_collection .back_link').forEach(function (backLink) {
      backLink.addEventListener('click', function (e) {
        e.preventDefault();
        e.stopPropagation();
        mobmenuMainView.style.display = '';
        menuMainBlock.style.display = '';
        collectionsViews.forEach(view => {
          view.classList.remove('is-collection-active');
          view.querySelectorAll('.menu_collection').forEach(col => {
            col.classList.remove('is-active', 'is-visible');
          });
        });
      });
    });
  });
  
 document.body.addEventListener('click', function (e) {
    const trigger = e.target.closest('.popup-trigger');
    if (trigger) {
      const popupId = trigger.getAttribute('data-popup-id');
      const popup = document.getElementById(popupId);
      if (popup) {
        popup.style.display = 'flex';
        document.body.style.overflow = 'hidden';
      }
    }

    if (e.target.matches('.close-popup') || e.target.closest('.close-popup')) {
      const popup = e.target.closest('.custom-popup');
      if (popup) {
        popup.style.display = 'none';
        document.body.style.overflow = ''; 
      }
    }

    if (e.target.classList.contains('custom-popup')) {
      e.target.style.display = 'none';
      document.body.style.overflow = ''; 
    }
  });
  
  // Overlay Cursor 
  document.addEventListener("mousemove", (e) => {
      const cursor = document.getElementById("cross_cursor");
      if (!cursor) return;

      cursor.style.left = e.clientX + "px";
      cursor.style.top = e.clientY + "px";
    });

    document.addEventListener("mouseover", (e) => {
      const overlay = e.target.closest("#CartDrawer-Overlay");
      const cursor = document.getElementById("cross_cursor");
      if (!cursor) return;

      if (overlay) {
        cursor.style.display = "block";
        overlay.style.cursor = "none"; 
      }
    });

    document.addEventListener("mouseout", (e) => {
      const overlay = e.target.closest("#CartDrawer-Overlay");
      const cursor = document.getElementById("cross_cursor");
      if (!cursor) return;

      if (overlay) {
        cursor.style.display = "none";
        overlay.style.cursor = "default";
      }
    });
    document.addEventListener("click", (e) => {
      const overlay = e.target.closest("#CartDrawer-Overlay");
      if (!overlay) return;

      const cartDrawer = document.querySelector("cart-drawer.drawer");
      const cursor = document.getElementById("cross_cursor");

      if (cartDrawer) {
        cartDrawer.classList.remove("active");
      }
      document.body.classList.remove("overflow-hidden");
      if (cursor) cursor.style.display = "none";
      overlay.style.cursor = "default";
    });


});


// JQuery
